<template>
  <div v-if="error === 'setup_incomplete'" class="flex flex-col items-center mt-6">
    <i class="fas fa-exclamation-triangle mb-3"></i>
    Setup incomplete for {{ selectedOffice.name }} ({{ selectedOffice.address_town }}). Please contact your account manager to get started.
  </div>
  <div v-else-if="error === 'list'" class="flex flex-col items-center mt-6">
    <i class="fas fa-exclamation-triangle mb-3"></i>
    Sorry, your reports are not available at this time.
  </div>
  <div v-else-if="reports === null" class="mt-6">
    <loader />
  </div>
  <div v-else>
    <div class="bg-white p-6 my-6 rounded-lg">
      <div class="w-full md:w-1/2 lg:w-1/3">
        <label class="block mb-2">Report</label>
        <select v-model="selectedReport" class="w-full block border p-3 bg-white">
          <option v-for="report in reports" :key="report.id" :value="report">
            {{ report.name }}
          </option>
        </select>
      </div>
    </div>

    <div v-if="error === 'report'" class="flex flex-col items-center mt-6">
      <i class="fas fa-exclamation-triangle mb-3"></i>
      Sorry, this report is not available at this time.
    </div>
    <loader v-else-if="!reportEmbed" />
    <power-bi-report
      v-else
      :id="reportEmbed.id"
      :embed-url="reportEmbed.embedUrl"
      :token="reportEmbed.reportToken.token"
      :filters="powerBiFilters"
      class="bg-white p-6 rounded-lg"
    />
  </div>
</template>

<script>
import api from '@/http'
import { mapState } from 'vuex'
import PowerBiReport from '../../components/PowerBiReport'

export default {
  components: { PowerBiReport },
  data () {
    return {
      is_admin: false,
      use_licence_areas: false,
      reports: null,
      filters: null,
      selectedReport: null,
      reportEmbed: null,
      error: null
    }
  },
  computed: {
    ...mapState(['selectedOffice']),
    powerBiFilters () {
      let output = []
      if (this.is_admin) {
        return output
      }

      let reportName = (this.selectedReport ? this.selectedReport.name : '').toLowerCase()

      if (this.filters.agents.length && reportName.indexOf('competitive') < 0) {
        output.push({
          $schema: 'http://powerbi.com/product/schema#basic',
          target: reportName.indexOf('valuation') >= 0 ? {
            table: 'AgentComparison',
            column: 'UniqueAgentName'
          } : {
            table: 'DistinctOffices',
            column: 'Name'
          },
          operator: 'In',
          values: this.filters.agents,
          filterType: 1,
          requireSingleSelection: false
        })
      }

      if (this.filters.outcodes.length) {
        output.push({
          $schema: 'http://powerbi.com/product/schema#basic',
          target: this.use_licence_areas ? {
            table: 'LicensedAreas',
            column: 'Outcode'
          } : {
            table: 'ProcessedListing',
            column: 'OutCode'
          },
          operator: 'In',
          values: this.filters.outcodes,
          filterType: 1,
          requireSingleSelection: false
        })
      }

      return output
    }
  },
  mounted () {
    this.getReports()
    this.trackPageVisit()
  },
  methods: {
    getReports () {
      this.reports = null
      this.reportEmbed = null
      this.selectedReport = null
      this.error = null

      api.get('insight', {
        params: {
          office_id: this.selectedOffice.id
        }
      }).then((response) => {
        this.is_admin = response.data.is_admin
        this.use_licence_areas = response.data.use_licence_areas
        this.reports = response.data.reports
        this.filters = response.data.filters
        if (this.reports.length) {
          this.selectedReport = this.reports[0]
        }
      }, (error) => {
        this.error = error.response.status === 422 ? 'setup_incomplete' : 'list'
      })
    },
    getReport () {
      if (this.selectedReport === null) {
        return
      }
      this.reportEmbed = null
      this.error = null

      api.get(`insight/${this.selectedReport.id}`, {
        params: {
          office_id: this.selectedOffice.id,
          type: this.selectedReport.type
        }
      }).then((response) => {
        this.reportEmbed = response.data
      }, () => {
        this.error = 'report'
      })
    },
    trackPageVisit () {
      api.post(process.env.VUE_APP_ROOT_API + '/data/product-use-log', {
        'office_id': this.selectedOffice.id,
        'product': 'Members Hub',
        'category_type': 'page_view',
        'category_value': 'competitor-analysis-report',
        'action_type': 'read',
        'quantity': 1
      })
    }
  },
  watch: {
    selectedReport () {
      this.getReport()
    },
    selectedOffice () {
      this.getReports()
    }
  }
}
</script>
